var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 155,
    viewBox: "0 0 124 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0056 119.651V155.001L124 119.193V83.8474L62.0056 119.651Z",
    fill: "#51BD7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.757 51.3784L120.346 33.7032L62.0056 0V35.3492L89.757 51.3784Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9116 61.9331V97.2938L62.0045 111.207V75.8622L37.9116 61.9331Z",
    fill: "#8CE3B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124 40.0393L62.0056 75.8622V111.207L124 75.3988V40.0393Z",
    fill: "#51BD7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69165 33.6826L34.0972 51.461L62.0045 35.3492V0L3.69165 33.6826Z",
    fill: "#2AD572"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5993 101.518V57.6926L0 40.0232V119.192L62.0046 155V119.65L30.5993 101.518Z",
    fill: "#4DDD8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.2aeac3bcbdad8d86b71fd1245aaa8efe.svg";
export { ForwardRef as ReactComponent };